export const PERSONALISATION_OPTIONS_ID = 'personalisation-options';
